/* eslint-disable */
import customModal from "../customModal/customModal.vue";

export default {
    name: "MitigationDetailsModal",
    components: { customModal },
    props: {
        data: Object,
    },
    emits: ["closeModal"],
};